import { render, staticRenderFns } from "./PricesChangedList.vue?vue&type=template&id=dbdb455c&scoped=true"
import script from "./PricesChangedList.vue?vue&type=script&lang=js"
export * from "./PricesChangedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdb455c",
  null
  
)

export default component.exports